var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('span',[_vm._v("COPYRIGHT © "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"#","target":"_blank","rel":"nofollow"}},[_vm._v("Elomark")]),_vm._v(", All rights Reserved")]),_c('span',{staticClass:"md:flex hidden items-center"})])
}
var staticRenderFns = []

export { render, staticRenderFns }